import { AnalyticsProvider as SharedAnalyticsProvider } from "@punto/frontend-shared/providers/analytics-provider";

import { config } from "@/lib/config";

export const AnalyticsProvider = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  return (
    <SharedAnalyticsProvider
      posthogKey={config.POSTHOG_KEY}
      posthogHost={config.POSTHOG_HOST}
      posthogDefaults="2026-01-30"
    >
      {children}
    </SharedAnalyticsProvider>
  );
};
